import { render, staticRenderFns } from "./trusteeshipFund.vue?vue&type=template&id=65003394&scoped=true"
import script from "./trusteeshipFund.vue?vue&type=script&lang=js"
export * from "./trusteeshipFund.vue?vue&type=script&lang=js"
import style0 from "./trusteeshipFund.vue?vue&type=style&index=0&id=65003394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65003394",
  null
  
)

export default component.exports